var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"band",class:{'is-white': !_vm.config.colors},style:(_vm.style)},[_c('div',{staticClass:"band-name"},[_vm._v(_vm._s(_vm._f("round")(_vm.value / 100,2)))]),(_vm.config.subtitles)?_c('div',{staticClass:"band-score"},[_vm._v(_vm._s(_vm.name))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }